<template>
  <div class="mt-4 p-3 border rounded-4 bg-light">
    <h4 class="mb-3">Configuración EposNow</h4>
    <div class="mb-3">
      <label for="eposnowToken" class="form-label">Token:<span class="text-danger">*</span></label>
      <input
        id="eposnowToken"
        type="text"
        class="form-control"
        v-model="localToken"
        @input="onTokenChange"
        maxlength="200"
        placeholder=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "FormEposNowComponent",
  props: {
    token: { type: String, default: "" }
  },
  data() {
    return {
      localToken: this.token
    };
  },
  watch: {
    token(val) {
      this.localToken = val;
    }
  },
  methods: {
    onTokenChange() {
      this.$emit("update:token", this.localToken);
    }
  }
};
</script>

<style scoped>

</style>
